<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 245 244"
    style="enable-background: new 0 0 245 244"
    xml:space="preserve"
  >
    <g>
      <circle class="st0" cx="122.6" cy="122" r="122" />
    </g>
    <rect x="18.9" y="102.2" class="st1" width="207.1" height="39.7" />
  </svg>
</template>

<script>
export default {
  name: 'MinusGreyIcon'
}
</script>
<style scoped>
.st0 {
  fill: #686868;
}
.st1 {
  fill: #ffffff;
}
</style>
